
export enum LANG {
  es, en
}